import $ from 'jquery'

function scrollAndOpenSection(targetId, sectionId) {
  const target = $(targetId).get(0)
  // NOTE: if headroom should stay pined
  //window.scroll(0, target.offsetTop - headerHeight())
  const selfAndParents = $(sectionId).parents('.collapse').addBack()
  // trigger async collapse function to update icons
  // immediately open self and parent sections, so scroll would work
  selfAndParents.addClass('show')
  selfAndParents.trigger('show.bs.collapse')
  // remove collapsed class in section head, so opened icons are shown
  selfAndParents.siblings('.section-head--collapsable').removeClass('collapsed')
  const headerHeight = $('.navbar--bsf').outerHeight(true)
  window.scroll(0, target.offsetTop - headerHeight)
  unPinHeadroom()
}

function waitForScrollEnd(cb) {
  let timer = null
  $(window).scroll(function() {
    if (timer !== null) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      $(window).off('scroll')
      cb()
    }, 150)
  })
}

function unPinHeadroom() {
  let $header = $('header')
  $header.addClass('header--custom-unpinned')
  waitForScrollEnd(() => {
    $header
      .addClass('slideUp')
      .removeClass('slideDown header--custom-unpinned')
  })
  return
}

$.fn.openSection = function() {
  return this.each(function() {
    const $src = $(this)
    $src.click(evt => {
      if ($src.is('[data-open-subsections]')) {
        $('.section-body', $src.attr('data-section')).collapse('show')
      }
      // manual scroll, to account for header height
      evt.preventDefault()
      scrollAndOpenSection($src.attr('href'), $src.attr('data-section'))
    })
  })
}

export function initIndexNavigation() {
  $('#index-navigation').change(() => {
    const $src = $('option:selected', this)
    scrollAndOpenSection($src.attr('data-href'), $src.attr('data-section'))
  })
}
